module.exports = __webpack_public_path__ + "img/banner-1.ed02e410.png";